module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--3-9be97379.png";